import React from 'react';
import { Card, CardContent } from './ui/card';
import { XCircle, CheckCircle2, X } from 'lucide-react';

const ComparisonSection = () => {
  return (
    <section className="py-32 bg-[#eeeeee] relative overflow-hidden" style={{ marginBottom: '150px' }}>
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <p className="text-sm font-semibold tracking-wider uppercase text-[#0079be] mb-3">
            Gestão de risco nas operações corporativas
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Comparativo de Redundância Falsa VS Redundância Verdadeira
          </h2>
        </div>

        {/* Comparison Cards */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-20" style={{ margin: '6rem 9rem' }}>
          {/* Redundância Vulnerável */}
          <div className="flex-1 max-w-xl animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
            <div className="relative">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 z-10">
                <span className="bg-red-500 text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg">
                  O RISCO
                </span>
              </div>
              <Card className="border-4 border-red-300 bg-red-50/80 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-2">
                <CardContent className="p-10">
                  <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                    Redundância Vulnerável
                  </h4>
                  <div className="space-y-5">
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <XCircle className="w-7 h-7 text-red-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-medium">Dois ou mais links de fibra</span>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <XCircle className="w-7 h-7 text-red-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-medium">Compartilham o mesmo caminho físico (postes)</span>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <XCircle className="w-7 h-7 text-red-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-medium">Uma única falha na rua = downtime total</span>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <XCircle className="w-7 h-7 text-red-500 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-medium">Operação exposta a riscos físicos</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          {/* VS Badge - X em destaque */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="relative">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center shadow-2xl animate-pulse">
                <X className="w-16 h-16 text-white font-bold" strokeWidth={4} />
              </div>
              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap">
                <span className="text-2xl font-black text-gray-700">VS</span>
              </div>
            </div>
          </div>

          {/* Mobile VS */}
          <div className="lg:hidden flex items-center justify-center py-8">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center shadow-xl">
              <X className="w-12 h-12 text-white font-bold" strokeWidth={4} />
            </div>
          </div>

          {/* Verdadeira Redundância */}
          <div className="flex-1 max-w-xl animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-200">
            <div className="relative">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 z-10">
                <span className="bg-green-500 text-white text-sm font-bold px-6 py-2 rounded-full shadow-lg">
                  A SOLUÇÃO TMC
                </span>
              </div>
              <Card className="border-4 border-green-300 bg-green-50/80 shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-2">
                <CardContent className="p-10">
                  <h4 className="text-2xl font-bold text-gray-900 mb-8 text-center">
                    A Verdadeira Redundância - TMC
                  </h4>
                  <div className="space-y-5">
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <CheckCircle2 className="w-7 h-7 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-bold">Fibra Terrestre + Rádio Digital</span>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <CheckCircle2 className="w-7 h-7 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-bold">Meios e caminhos 100% independentes</span>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <CheckCircle2 className="w-7 h-7 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-bold">Redundância Automática dos links</span>
                    </div>
                    <div className="flex items-start space-x-4 bg-white/70 p-4 rounded-lg">
                      <CheckCircle2 className="w-7 h-7 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700 text-lg font-bold">Continuidade de negócios garantida</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-20 text-center animate-on-scroll opacity-0 translate-y-8 transition-all duration-700">
          <div className="bg-[#0079be] text-white rounded-2xl p-8 md:p-12 shadow-xl max-w-5xl mx-auto">
            <p className="text-xl md:text-2xl font-bold leading-relaxed">
              Cada hora sem comunicação pode representar um custo{' '}
              <span className="text-yellow-400">IMENSURÁVEL</span> para sua empresa.
              <br className="hidden md:block" />
              <span className="text-yellow-400">Não é apenas um problema de TI, é sim um problema de negócios.</span>
              <br className="hidden md:block" />
              Será que vale a pena o risco?
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
